export default "/images/cdlTruckPhotoroom.png?f2298c5b7b60e9cfafe620fd2b9b4a72";